// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      activityModelOptions: [
        "NA",
        "Sample",
        "Area",
        "Asset",
        "Risk"
      ],
      // eslint-disable-next-line
      activityMethodOptions: [
        "Time",
        "RBM",
        "RBI"
      ],
      // eslint-disable-next-line
      activityOwnerOptions: [
        "O",
        "M",
        "E"
      ],
      // eslint-disable-next-line
      activityJustifyOptions: [
        "Regulation",
        "Safety",
        "Reliability",
        "Cost",
        "Carbon"
      ],
      // eslint-disable-next-line
      activityConditionOptions: [
        "Online",
        "Offline",
        "Isolate",
        "Factory",
        "Special"
      ],
      // eslint-disable-next-line
      activityResourceImpactOptions: [
        "R0",
        "R1",
        "R2",
        "R3"
      ],
      // eslint-disable-next-line
      activityDriverOptions: [
        "Regulation",
        "Safety", // hazardous operation (light is sparking but working)
        "Production", // loss of function
        "Efficiency", // loss of function
        "Standard", // loss of function
        "Industry", // loss of function
        "Study", // catstrophic failure light operation resuled in fire
        "Vendor" // degraded operation light inesnity is lower
      ],
      // eslint-disable-next-line
      activityTimeOptions: [
        "Online", // investion visual
        "Offline", // inspection detail
        "Isolate", // system alarm
        "Factory", // system trip
        "Special",
        "Other"
      ],
      // eslint-disable-next-line
      activityTypeOptions: [
        "Routine",
        "Inspect",
        "Test",
        "Replace",
        "Refurb",
        "Major",
        "Review",
        "Audit"
      ],
      // eslint-disable-next-line
      activityFrequencyOptions: [
        "D",
        "W",
        "M",
        "Y"
      ]
    };
  }
};
